const setCalendarEntry = (schedules, setEvents, currentUsername = null) => {
  const calendarEntry = [];
  schedules.map((schedule) => {
    if (!schedule.post) return;

    let scheduleDate = schedule.scheduled_for || schedule.posted_at;

    if (!scheduleDate) return;

    const startDate = new Date(scheduleDate);
    const types = [];

    types.push(schedule.post.post_type);
    types.push(schedule.post.content_type);

    let status = schedule.post_status;
    if (typeof status === "undefined" || status === null) {
      // A schedule planned on someone else's account is "planned" only once approved.
      status = schedule.approval_status === "proposed" ? "proposed" : "planned";
    }

    const entry = {
      id: schedule.post.id,
      scheduleId: schedule.id,
      title: schedule.post.title,
      text: schedule.post.text,
      postDate: schedule.scheduled_for,
      timezone: schedule.timezone,
      start: new Date(startDate),
      end: new Date(startDate.getTime() + 60 * 60 * 1000),
      status: status,
      types: types,
      contentType: schedule.post.content_type,
      platforms: schedule.platforms ?? (schedule.platform ? [schedule.platform] : ["linkedin"]),
      stats: schedule.post.stats?.at(-1),
      planning: schedule.planning ? true : false,
      draft: schedule.post.draft,
      publishAs: schedule.publish_as?.name || schedule.publish_as?.username || null,
      approvalStatus: schedule.approval_status ?? null,
      plannedBy: schedule.planned_by?.name || schedule.planned_by?.username || null,
      plannedByUser: schedule.planned_by ?? null,
      // Collaboration groups the post is shared in: [{id, name}] from the listing.
      sharedIn: Array.isArray(schedule.post.shared_in) ? schedule.post.shared_in : [],
      // Someone else's post that publishes on my account: read-only for me.
      delegatedToMe: Boolean(currentUsername && schedule.publish_as?.username === currentUsername),
    };
    calendarEntry.push(entry);
  });
  setEvents(calendarEntry);
};

export default setCalendarEntry;
